import { bridge } from '../../../bridge';
import { appendParams, buildUrl, finalizeUrl } from '../../utils';

export const moveToScreens = (screenName: string) => {
  const link = buildUrl('ably://screens');
  appendParams(link, 'screen_name', screenName);
  bridge.openDeeplink(finalizeUrl(link));
};
